import type { Content as ContentType } from 'types/capi/content';

import Content from '~/components/Content';

type Props = {
  content?: ContentType[];
  narrow?: boolean;
  title?: string;
};

export default function ContentBlock({ content, title, narrow }: Props) {
  const items = content || [];

  if (!title && items.length === 0) return null;

  const containerWidth = narrow
    ? 'max-w-[226px] lg:max-w-[456px] xl:max-w-[552px]'
    : 'max-w-[343px] sm:max-w-[522px] md:max-w-[776px] lg:max-w-[936px]';

  return (
    <div className="flex w-full items-center justify-center py-8">
      <div className={`flex ${containerWidth} flex-col gap-6`}>
        {title && <h3 className="w-full text-lg font-bold">{title}</h3>}
        {items.length > 0 && <Content content={items} />}
      </div>
    </div>
  );
}
